import { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { debounce, capitalize } from "lodash";
import Dropdown from "@shared/v2/Dropdown";
import TextInput from "@shared/v2/TextInput";

const SearchInput = ({ onSearch, options }) => {
  const dropdownOptions = useMemo(
    () =>
      [{ label: "All Roles", value: "" }].concat(
        options.map((o) => ({
          value: o,
          label: capitalize(o),
        })),
      ),
    [options],
  );
  const [currentSearchTerm, _setCurrentSearchTerm] = useState(
    new URLSearchParams(window.location.search).get("q") || "",
  );
  const [currentRoleFilter, setCurrentRoleFilter] = useState(
    new URLSearchParams(window.location.search).get("role") || "",
  );

  const setCurrentSearchTerm = useMemo(() => debounce(_setCurrentSearchTerm, 200), []);

  useEffect(() => {
    onSearch(currentSearchTerm, currentRoleFilter);
  }, [currentSearchTerm, currentRoleFilter]);

  return (
    <div className="tw-flex">
      <Dropdown
        options={dropdownOptions}
        value={dropdownOptions.find((o) => o.value === currentRoleFilter)}
        onChange={(o) => setCurrentRoleFilter(o.value)}
      />
      <TextInput placeholder="Search by Email" onChange={(e) => setCurrentSearchTerm(e.target.value)} />
    </div>
  );
};

SearchInput.propTypes = {
  onSearch: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SearchInput;
